import { Component, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { addUser, Employee } from '../../shared/misc-classes';
import { DataService } from '../../shared/dataservice.service';
// import { setTimeout } from 'timers';
@Component({
  selector: 'token-field',
  templateUrl: './token-field.component.html',
  styleUrls: ['./token-field.component.css']
})
export class TokenFieldComponent implements OnChanges {
  @Input() users:Array<addUser>;
  @Output() userAdded = new EventEmitter();
  @Output() userRemoved = new EventEmitter();

  isSearchInFocus:boolean = false;
  searchText:string = '';
  matchedValues:Array<any>=[];
  employeeList:Array<Employee>;
  userenterd:Array<any>=[];
  mId:string="";
  constructor(private _dataservice:DataService) { 
    setTimeout(()=>{
      this.employeeList = this._dataservice.employeeList;
    },300)
  }

  ngOnChanges() {
  }

  hasEditAccess(_pid:string){
    return this._dataservice.hasEditAccess(this.mId,_pid);
  }
  searchFocusIn(){
    this.isSearchInFocus = true;
  }
  valueChanged(userenterd){ 
    this.matchedValues=[];
      for(var i=0;i<this.employeeList.length;i++){
        if((this.employeeList[i].Name).toLowerCase().indexOf(userenterd.toLowerCase()) !== -1 ){
          this.matchedValues.push(this.employeeList[i].Name);
        }
      }    
    
  }

  searchFocusOut(){
    this.isSearchInFocus = false;
  }

  // searchKeyPress(_evnt){
  //   let keyCode:number = _evnt.keyCode;
  //   if(keyCode==13){
  //     if(this.isValidEmail(_evnt) == true){
  //       this.userAdded.emit(_evnt.target.value);
  //       _evnt.target.value = '';
  //       this.matchedValues=[];
  //     }
  //   }
  // }
  prsnSelected(_evnt){
    if(this.isValidEmail(_evnt) == true){
      this.userAdded.emit(_evnt);
      this.matchedValues=[]; 
      this.userenterd = [];   
    }
    // setTimeout(()=>{
    //   this.isSearchInFocus = false
    // },3000)
  }

  isValidEmail(_e){
    return true;
  }

  removeUser(_index){
    if(_index < this.users.length){
      this.userRemoved.emit(this.users[_index].email);
    }
  }
}
